import { Search } from '@mui/icons-material';
import { Box, Stack, TextField } from '@mui/material';

const SampleFormControls = () => (
  <Box sx={{ padding: '10px 0' }}>
    <Stack
      direction="row"
      spacing={2}
      sx={{ justifyContent: 'flex-end', marginTop: '10px' }}
    >
      <TextField
        id="search-hpo"
        variant="outlined"
        placeholder="Search"
        size="small" //  This is the key to match button size
        // onKeyDown={(e) => e.key === 'Enter' && handleSearchClick(e)}
        fullWidth
        // value={searchQuery}
        // inputRef={inputRef}
        // onChange={handleSearchChange}
        sx={{ backgroundColor: 'background.paper' }}
        InputProps={{
          startAdornment: (
            <Search
              style={{
                paddingRight: '0.5rem',
              }}
            />
          ),
        }}
      />
    </Stack>
  </Box>
);

export default SampleFormControls;
